import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import HomeDetails from '../views/Homedetails.vue';
import List from '../views/list.vue';
import Leve from '../views/tou.vue';
import rolesDel from '../views/rolesDel.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: false, // 需要缓存
    },
  },
  {
    path: '/homeDetails',
    name: 'HomeDetails',
    component: HomeDetails,
  },
  {
    path: '/list',
    name: 'List',
    component: List,
    meta: {
      keepAlive: false, // 需要缓存
    },
  },
  {
    path: '/leve',
    name: 'Leve',
    component: Leve,
  },
  {
    path: '/rolesDel',
    name: 'rolesDel',
    component: rolesDel,
  },
  // 平台通知
  {
    path: '/platformNotifications',
    name: 'platformNotifications',
    component: () => import('../views/platformNotifications'),
    meta: {
      name: '平台通知',
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
